import { useSelector } from 'react-redux';

export const Consignor = ({ renderForm }) => {
  const dataSource = useSelector((state) => state.Actor.consignor)
  return renderForm ? renderForm({
    actorType: "consignor",
    boxNumber: "2",
    disabled: false,
    actorName: "ENTITY Name",
    dataSource: dataSource,
  }) : null
}